var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 57,
    viewBox: "0 0 62 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.164 33.0649L34.0251 53.9986L2.72225 29.6459L10.7209 0.742797C10.7209 0.742797 14.0664 15.8992 21.7244 17.4436C29.0576 18.9225 38.0613 7.45869 38.0613 7.45869C38.0613 7.45869 33.326 23.9206 39.6481 30.1895C45.3925 35.8855 60.164 33.0649 60.164 33.0649Z",
    stroke: "#1B3B5F",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.1abbf4c90fe225778b8d59b2a6db19e4.svg";
export { ForwardRef as ReactComponent };